module.exports = __webpack_public_path__ + "static/img/ab_.f93f46c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/ab_.jpg
// module id = TSoQ
// module chunks = 12